import { render, staticRenderFns } from "./DashBoardAdmin.vue?vue&type=template&id=6aee8a32"
import script from "./DashBoardAdmin.vue?vue&type=script&lang=js"
export * from "./DashBoardAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports